export const stripHtmlString = (stringWithTags: string) => {
  if (!stringWithTags) {
    return '';
  }

  const div = document.createElement('div');
  div.innerHTML = stringWithTags.replace(/<br ?\/?>/g, '\n');
  return div.textContent || div.innerText || '';
};
